// REYCRO content — Ian M. Reynaud Croda. Edit freely to update site content.

export const BRAND = {
  name: "REYCRO",
  realName: "Ian M. Reynaud Croda",
  tagline: "Built to move. Wired to create.",
  hero: "Hybrid Athlete × Music Producer",
  origin: "Mexican-Italian · Based in Barcelona",
  founded: 2017,
};

export const NAV = [
  { id: "about", label: "About" },
  { id: "music", label: "Music" },
  { id: "sports", label: "Sports" },
  { id: "map", label: "Journey" },
  { id: "mediakit", label: "Media Kit" },
  { id: "sponsorship", label: "Partner" },
  { id: "contact", label: "Contact" },
];

export const ABOUT = {
  label: "The Origin",
  heading: "Hybrid Performance Culture",
  paragraphs: [
    "REYCRO is not just music or just sports. It's a philosophy that unites discipline, art, creativity, and mentality. \"REYCRO\" fuses two surnames — REYnaud and CROda — representing Mexican and Italian roots, family, and history.",
    "Ian is a music producer, DJ, and hybrid athlete based in Barcelona. Graduated in International Business Administration, ICON Collective alumni, currently pursuing an MSc in Sports Management at EAE Barcelona.",
    "Founded in 2017, REYCRO Sports was born as the athletic extension of the energy REYCRO Music started — the point where the beat meets physical effort, flow, and personal overcoming.",
  ],
  pillars: [
    { title: "Mission", text: "Inspire a generation to elevate mind and body through rhythm, discipline, exercise, and consistency." },
    { title: "Vision", text: "Transform REYCRO into a global brand connecting music, physical and mental performance." },
    { title: "Purpose", text: "Prove discipline is a universal language — in study, the studio, the gym, on stage, in competition." },
  ],
  credentials: [
    "ICON Collective Alumni — Advanced Music Production",
    "MSc Sports Management @ EAE Barcelona",
    "BBA International Business — UDLAP, Mexico (2017–2022)",
    "BBA International Business — NEOMA BS, France (2019–2021)",
    "Ableton Live · Pro Tools · Wavelab",
  ],
};

export const SPORTS = {
  label: "REYCRO Sports",
  heading: "Discipline in Motion",
  stats: [
    { value: "17", label: "Spartan Races" },
    { value: "4", label: "Spartan Trifectas" },
    { value: "1", label: "HYROX Barcelona" },
    { value: "5", label: "Volunteer Crews" },
  ],
  disciplines: ["Spartan Race", "HYROX", "OCR", "Trail", "Strength"],
  upcoming: [
    { event: "HYROX Barcelona Solo Open · Nov 14, 2026", tag: "Race" },
    { event: "Spartan Super — Morzine · Jul 5, 2026", tag: "Race" },
    { event: "Spartan Beast — Estérel Saint-Raphaël · European Championship · Oct 2026", tag: "Done" },
    { event: "Spartan Ultra World Championship — Morzine 2026", tag: "Volunteer" },
  ],
  nextRaces: [
    { label: "HYROX Barcelona Solo Open", date: "2026-11-14T09:00:00" },
  ],
  professional: [
    { event: "Sports Summit Madrid 2026", tag: "Summit" },
    { event: "MSc Sports Management — EAE Barcelona", tag: "Studies" },
    { event: "Advanced Music Production — ICON Collective (2023–2024)", tag: "Course" },
    { event: "BBA International Business — UDLAP, Mexico (2017–2022)", tag: "Degree" },
    { event: "BBA International Business — NEOMA BS, France (2019–2021)", tag: "Degree" },
  ],
  gallery: [
    { url: "https://images.pexels.com/photos/35706575/pexels-photo-35706575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Fire jump · Spartan Race" },
    { url: "https://images.pexels.com/photos/35717493/pexels-photo-35717493.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Obstacle finish line" },
    { url: "https://images.pexels.com/photos/35006998/pexels-photo-35006998.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "HYROX prep" },
    { url: "https://images.pexels.com/photos/34852961/pexels-photo-34852961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Box jumps · Functional" },
  ],
};

export const MUSIC = {
  label: "REYCRO Music",
  heading: "Beats Meet Effort",
  services: [
    { title: "Beats — Original & Leasing", desc: "Drill, Trap, Reggaeton, EDM, Custom, Multi-genre.", href: "https://reycromusic.beatstars.com", external: true },
    { title: "Mix & Master", desc: "Professional mixing and sound engineering.", href: "mailto:reycromusic@gmail.com" },
    { title: "DJ & Live Production", desc: "Sets, events, streaming, brand activations.", href: "mailto:reycromusic@gmail.com" },
    { title: "SYNC for Brands", desc: "Custom music for athletes & brands.", href: "mailto:reycromusic@gmail.com" },
  ],
  genres: ["Drill", "Trap", "Reggaeton", "EDM", "Custom", "Multi-genre"],
  catalog: [
    "TÊTE (feat. Medy & VillaBanks)",
    "A VOLTE (YOU & I)",
    "SEMBRA FACILE",
    "ABITUDINE",
    "REAL GANGSTA LOVE",
    "CAN'T RUSH GREATNESS",
    "PARTY MONSTER",
    "PULL ME CLOSER",
  ],
  platforms: [
    { name: "Spotify", href: "https://open.spotify.com/artist/5b4UYB9PP6PtkPdiijz1hk" },
    { name: "SoundCloud", href: "https://soundcloud.com/reycro" },
    { name: "YouTube", href: "https://www.youtube.com/@reycro" },
    { name: "BeatStars", href: "https://reycromusic.beatstars.com" },
  ],
  spotifyArtistId: "5b4UYB9PP6PtkPdiijz1hk",
  youtubeUrl: "https://www.youtube.com/@reycro",
  beatstarsUrl: "https://reycromusic.beatstars.com",
  gallery: [
    "https://images.pexels.com/photos/18197126/pexels-photo-18197126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/5749191/pexels-photo-5749191.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/7649012/pexels-photo-7649012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
};

// Interactive world map — Spartan/HYROX races & volunteering. lat/lng + type.
// types: spartan | hyrox | volunteer
// To add event photos to a pin's popup, add a `photos` array of image URLs, e.g.:
//   { id: 10, name: "Los Angeles · USA", ..., photos: ["https://.../1.jpg", "https://.../2.jpg"] }
export const MAP_LOCATIONS = [
  // --- Spartan · Athlete ---
  { id: 1, name: "Stoneham, Québec · Canada", lat: 47.1330, lng: -71.3760, type: "spartan", title: "Spartan Sprint", note: "2016 · Athlete", date: "2016-06-06", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1x9fz2uy_IMG_1059%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/7tlmxmys_IMG_1060%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/rioe4l7m_IMG_1061%202.jpg",
  ] },
  { id: 2, name: "Huixquilucan · Mexico", lat: 19.3600, lng: -99.3520, type: "spartan", title: "Spartan Sprint", note: "2018 · Athlete", date: "2018-04-21", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ecdagqcf_IMG_1878.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/2xennly9_IMG_1879.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/pg9be5y4_IMG_1880.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/kffrq1q0_IMG_1881.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3qsljntd_IMG_1882.jpg",
  ] },
  { id: 3, name: "Puebla · Mexico", lat: 19.0414, lng: -98.2063, type: "spartan", title: "Spartan Super", note: "2018 · Athlete", date: "2018-06-16", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/gvhd9jku_IMG_1896.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/hdd8g5t5_IMG_1897.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/0nq8in0h_IMG_1898.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/eybk31c2_IMG_1899.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/wzd5mnvs_IMG_1900.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/v4sdcpt1_IMG_1901.jpg",
  ] },
  { id: 4, name: "Nevado de Toluca · Mexico", lat: 19.1080, lng: -99.7580, type: "spartan", title: "Spartan Super", note: "2018 · Athlete", date: "2018-10-06", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/mmry4ukm_IMG_1767.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/nu98q8ky_IMG_1768.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/bzsirox3_IMG_1769.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/cra8nhiq_IMG_1770.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/josotaq7_IMG_1771.jpg",
  ] },
  { id: 5, name: "San Luis Potosí · Mexico", lat: 22.1565, lng: -100.9855, type: "spartan", title: "Spartan Beast", note: "2018 · Athlete", date: "2018-11-24", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/dq7rd4di_IMG_1929.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/fvsmcfe5_IMG_1927.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/35szrsuk_IMG_1928.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/70isohs6_IMG_1930.jpg",
  ] },
  { id: 6, name: "Colegio Militar · Mexico City", lat: 19.2710, lng: -99.1710, type: "spartan", title: "Spartan Sprint", note: "2022 · Athlete", date: "2022-08-13", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/rhkqcx3x_IMG_1911.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/2knjd7aa_IMG_1912.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/8ld8cw02_IMG_1913.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ucsmlu4e_IMG_1914.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/eu95je3s_IMG_1915.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/xa6kehkf_IMG_1916.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/7zisp2jn_IMG_1917.jpg",
  ] },
  { id: 7, name: "Acapulco · Mexico", lat: 16.8531, lng: -99.8237, type: "spartan", title: "Spartan Sprint", note: "2022 · Athlete", date: "2022-12-03", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ykrdswcu_IMG_1910.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/z9158zau_IMG_1902.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/blm2x9cn_IMG_1903.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/4lmdxwjo_IMG_1904.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/5m1p0cjq_IMG_1905.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/q9fuhz3s_IMG_1906.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/86k3z8xw_IMG_1907.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/q4mj6ms9_IMG_1908.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/c9071ale_IMG_1909.jpg",
  ] },
  { id: 8, name: "Seattle · USA", lat: 47.6062, lng: -122.3321, type: "spartan", title: "Spartan Super", note: "2023 · Athlete", date: "2023-09-17", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/be4h97xu_IMG_1948.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/0kxmeal7_IMG_1949.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/4tp7vnhd_IMG_1950.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/pqykx40k_Disen%CC%83o%20sin%20ti%CC%81tulo.jpg",
  ] },
  { id: 9, name: "San Luis Obispo · USA", lat: 35.2828, lng: -120.6596, type: "spartan", title: "Spartan Beast", note: "2023 · Athlete", date: "2023-11-04", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/2nk20kto_IMG_1931.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/qbhyhngs_IMG_1932.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/zmx4na9e_IMG_1934.jpg",
  ] },
  { id: 10, name: "Santa Clarita, CA · USA", lat: 34.3917, lng: -118.5426, type: "spartan", title: "Spartan Sprint", note: "2023 · Athlete", date: "2023-12-02", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/6oeml3zp_IMG_1942.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/kzzxtr4j_IMG_1943.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/vqo31oek_IMG_1944.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/jmigrqh1_IMG_1945.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3fapopc9_IMG_1946.jpg",
  ] },
  { id: 11, name: "Dodger Stadium, Los Angeles · USA", lat: 34.0739, lng: -118.2400, type: "spartan", title: "Spartan Stadium", note: "2024 · Athlete", date: "2024-02-24", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/rw1evyl8_IMG_1935.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/bsxm1z0k_IMG_1936.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/t52a8ovh_IMG_1937.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1qmt2bzq_IMG_1938.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ghv4b5wm_IMG_1939.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/erl4pisw_IMG_1940.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/5eiajeh5_IMG_1941.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3z6s8tcl_IMG_1975.jpg",
  ] },
  { id: 12, name: "Valle de Bravo · Mexico", lat: 19.1953, lng: -100.1306, type: "spartan", title: "Spartan Sprint", note: "2025 · Athlete", date: "2025-05-24", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/moanxues_20250524_104246_02_2%5B113205425%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/c2cwepdb_20250524_104834_03_2%5B113207233%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ee6skk7n_20250524_114344_06%5B113205806%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/69hdqo4g_20250524_115102_05_1%5B113206933%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/9e8zaaq0_20250524_115238_07_10%5B113206483%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/b1650sl9_20250524_115322_01%5B113205615%5D.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/udv812s1_20250524_122433_04%5B113205986%5D.jpg",
  ] },
  { id: 13, name: "Valle de las Piedras Encimadas, Puebla · Mexico", lat: 19.9300, lng: -97.9600, type: "spartan", title: "Spartan Super", note: "2025 · Athlete", date: "2025-06-28", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/bkjply8l_IMG_1918.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/dvewllw9_IMG_1919.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3mqjdya6_IMG_1920.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/uiaq89ll_IMG_1921.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/e12is4em_IMG_1922.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/cp8mwsz3_IMG_1923.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/9g5fr1sk_IMG_1924.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/44xhdm69_IMG_1925.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/dw57pxjg_IMG_1926.jpg",
  ] },
  { id: 14, name: "Le Dramont, Saint-Raphaël · France", lat: 43.4256, lng: 6.8497, type: "spartan", title: "Spartan Beast", note: "2025 · Athlete", date: "2025-10-04", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/5sl8ofoq_IMG_1963.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/yuf6661t_IMG_1964.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/kdcjdt8u_IMG_1965.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/p4mtpg8d_IMG_1966.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/4iqp1rx3_IMG_1967.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/tplyh7wb_IMG_1968.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3kqycbcr_IMG_1969.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/tlstg9uy_IMG_1970.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/vtl256a4_IMG_1971.jpg",
  ] },
  { id: 23, name: "Le Dramont, Saint-Raphaël · France", lat: 43.4270, lng: 6.8513, type: "spartan", title: "Spartan Beast · European Championship", note: "Oct 2026 · Beast Finisher · Trifecta", date: "2026-10-03", heroFocus: "center 22%", photos: [
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/f1fb03ea14bd10d3_WhatsApp%20Image%202026-10-09%20at%2019.24.55%20%283%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/8dd0328f531ea745_WhatsApp%20Image%202026-10-09%20at%2019.24.55%20%282%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/c4af1d3bb2ffb862_WhatsApp%20Image%202026-10-09%20at%2019.24.55%20%281%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/c721659b51f10be0_WhatsApp%20Image%202026-10-09%20at%2019.24.55%20%285%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/8d6ac950e6af77df_WhatsApp%20Image%202026-10-09%20at%2019.24.55%20%284%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/1b5f6e1a52696652_WhatsApp%20Image%202026-10-09%20at%2019.24.54%20%282%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/d8cdf91b7456f0e0_WhatsApp%20Image%202026-10-09%20at%2019.24.54%20%281%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/1a34ae130d1e06c1_WhatsApp%20Image%202026-10-09%20at%2019.24.54%20%283%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/a97efefa122d6b1c_WhatsApp%20Image%202026-10-09%20at%2019.24.54%20%284%29.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/335033f871322a30_WhatsApp%20Image%202026-10-09%20at%2019.24.55.jpeg",
    "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/0e21f770de6453cd_WhatsApp%20Image%202026-10-09%20at%2019.24.54.jpeg",
  ] },
  { id: 15, name: "Valmorel · France", lat: 45.4606, lng: 6.4456, type: "spartan", title: "Spartan Sprint", note: "2026 · Athlete", date: "2026-03-22", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ksrl4d7c_Screenshot%202026-06-21%20at%204.06.10%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3rtam550_Screenshot%202026-06-21%20at%204.06.31%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/783uje95_Screenshot%202026-06-21%20at%204.06.54%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/9u8mm6xi_Screenshot%202026-06-21%20at%204.07.08%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/wtmla4ts_Screenshot%202026-06-21%20at%204.07.36%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/hp3g0xtr_Screenshot%202026-06-21%20at%204.07.52%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/qt7akv7c_Screenshot%202026-06-21%20at%204.08.02%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/znreioye_Screenshot%202026-06-21%20at%204.08.21%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/zasz4pes_Screenshot%202026-06-21%20at%204.08.38%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/m7s47qhm_Screenshot%202026-06-21%20at%204.08.46%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/3u85nlo7_Screenshot%202026-06-21%20at%204.09.00%E2%80%AFp.m..png",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/szz626jx_Screenshot%202026-06-21%20at%204.09.19%E2%80%AFp.m..png",
  ] },
  { id: 16, name: "Morzine · France", lat: 46.1791, lng: 6.7094, type: "spartan", title: "Spartan Super", note: "Jul 5, 2026 · Athlete", date: "2026-07-05", heroZoom: 1.05, heroFocus: "center 32%", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/tjvi5d18_IMG_2804.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/pvkngzi8_IMG_2797.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ercku5d5_IMG_2842.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/04ybcmao_IMG_2832.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/03o0jpn8_IMG_2839.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/a4mgt6ov_IMG_2835.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/du3ph7gy_IMG_2833.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/fiwaolfv_IMG_2834.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/0b92l1ip_IMG_2827.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/986f0vu0_IMG_2830.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/j0h2kujd_IMG_2821.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/y5s6pcf8_IMG_2823.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/x3d032sz_IMG_2812.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/jyclj6fs_IMG_2809.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/yqwvlzja_IMG_2806.webp",
  ] },

  // --- HYROX · Athlete ---
  { id: 24, name: "Fira Gran Via, Barcelona · Spain", lat: 41.3545, lng: 2.1280, type: "hyrox", title: "HYROX Solo Open", note: "May 16, 2026 · Athlete", date: "2026-05-16", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1ogz0lup_20763_20260516_134037_698334754_original.JPG",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/jbj6hmfz_20763_20260516_134039_698334770_original.JPG",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/wx6k1o90_20763_20260516_140147_698247991_original.JPG",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/x7r7al20_IMG_1763.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/y8js9d01_IMG_1764.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/25zrgck3_IMG_1765.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/e0321dny_IMG_1766.jpg",
  ] },
  { id: 17, name: "Fira Gran Via, Barcelona · Spain", lat: 41.3553, lng: 2.1297, type: "hyrox", title: "HYROX Solo Open", note: "Nov 14, 2026 · Athlete", date: "2026-11-14" },

  // --- Spartan · Volunteer ---
  { id: 18, name: "Santa Susanna, Barcelona · Spain", lat: 41.6390, lng: 2.7100, type: "volunteer", title: "Spartan · Volunteer", note: "2025 · Crew", date: "2025-10-19", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/lbrxnc1o_IMG_1983.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/j16cwcho_IMG_1984.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/jd8fxko1_IMG_1985.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/tp1y7872_IMG_1986.jpg",
  ] },
  { id: 19, name: "Valmorel · France", lat: 45.4700, lng: 6.4550, type: "volunteer", title: "Spartan · Volunteer", note: "2026 · Crew", date: "2026-03-21", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/sbmun05h_IMG_1987.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/sf6t0pub_IMG_1988.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/2zq49ma0_IMG_1989.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/mju5g4rq_IMG_1990.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/e0ysvic9_IMG_1991.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/wxhjjthg_IMG_1992.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/lta5pxm9_IMG_1993.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/g30hst1c_IMG_1994.jpg",
  ] },
  { id: 20, name: "Morzine · France", lat: 46.1890, lng: 6.7200, type: "volunteer", title: "Spartan · Volunteer", note: "2026 · Crew", date: "2026-07-03", heroFocus: "center 42%", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/o3gf1v8m_IMG_2513.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/fjtgcut3_IMG_2474.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/wvjsre2h_IMG_2488.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/l3injwla_IMG_2491.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/2iu4b6b1_IMG_2523.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/6o09ey4l_IMG_2526.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/w2jse399_IMG_2529.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/18uquifp_IMG_2530.webp",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1iea0qoq_IMG_2531.webp",
  ] },

  // --- HYROX · Volunteer ---
  { id: 21, name: "Madrid · Spain", lat: 40.4168, lng: -3.7038, type: "volunteer", title: "HYROX · Volunteer", note: "2025 · Crew", date: "2025-11-30", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1iwf1gh8_IMG_1978.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/k1ncr89u_IMG_1982.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/zu1ztr3q_IMG_1979.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ckt32lb9_IMG_1980.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/c8ws9aup_IMG_1981.jpg",
  ] },
  { id: 22, name: "Fira Gran Via, Barcelona · Spain", lat: 41.3537, lng: 2.1265, type: "volunteer", title: "HYROX · Volunteer", note: "2026 · Crew", date: "2026-05-14", heroFocus: "center 22%", photos: [
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/rkmk6ao7_IMG_1973%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/xz6ivczr_IMG_1976%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/zsllngup_IMG_1977%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/ra175kzh_IMG_1972%202.jpg",
    "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/mxczoeam_IMG_1974%202.jpg",
  ] },

  // --- Lived (home bases) ---
  { id: 30, name: "Québec · Canada", lat: 46.8139, lng: -71.2080, type: "lived", title: "Lived", note: "Home base" },
  { id: 31, name: "Edgerton, Wisconsin · USA", lat: 42.8355, lng: -89.0679, type: "lived", title: "Lived", note: "Home base" },
  { id: 32, name: "Reims · France", lat: 49.2583, lng: 4.0317, type: "lived", title: "Lived", note: "Home base" },
  { id: 33, name: "Lyon · France", lat: 45.7640, lng: 4.8357, type: "lived", title: "Lived", note: "Home base" },
  { id: 34, name: "Puebla · Mexico", lat: 19.0500, lng: -98.2200, type: "lived", title: "Lived", note: "Home base" },
  { id: 35, name: "Veracruz · Mexico", lat: 19.1738, lng: -96.1342, type: "lived", title: "Lived", note: "Home base" },
  { id: 36, name: "Los Angeles · USA", lat: 34.0522, lng: -118.2437, type: "lived", title: "Lived", note: "Home base" },
  { id: 37, name: "Barcelona · Spain", lat: 41.3874, lng: 2.1686, type: "lived", title: "Lived", note: "Home base" },
];

export const MAP_LEGEND = [
  { type: "spartan", label: "Spartan", color: "#BAF173" },
  { type: "hyrox", label: "HYROX", color: "#6735FA" },
  { type: "volunteer", label: "Volunteer", color: "#11E5B4" },
  { type: "lived", label: "Lived", color: "#F4A64B" },
];

export const MEDIA_KIT = {
  label: "Media Kit 2026",
  heading: "The Numbers",
  socials: [
    { handle: "@reycrosports", platform: "Instagram", followers: "916", views: "+30K", note: "Engaged hybrid-sports community", href: "https://www.instagram.com/reycrosports/" },
    { handle: "@reycromusic", platform: "Instagram", followers: "756", views: "+15K", note: "12+ beats published", href: "https://www.instagram.com/reycromusic/" },
    { handle: "Ian Reynaud", platform: "LinkedIn", followers: "1,883", note: "Posts · creator industry", href: "https://www.linkedin.com/in/ianreynaud/" },
  ],
  audience: {
    age: "20 – 35",
    profile: "High-performance creators, amateur & pro athletes, music enthusiasts.",
    location: "Spain (Barcelona, Madrid) · Mexico · LATAM in Europe",
    split: [
      { label: "Sports", value: 40 },
      { label: "Music", value: 40 },
      { label: "Personal", value: 20 },
    ],
  },
  market: [
    { stat: "100+", text: "Global HYROX events in 2024 (from 3 in 2018)" },
    { stat: "500K+", text: "Registered HYROX participants" },
    { stat: "40+", text: "Countries with Spartan Race" },
    { stat: "$1T", text: "Creator economy projected by 2027" },
  ],
};

export const SPONSORSHIP = {
  label: "Partner With REYCRO",
  heading: "Where the Beat Meets the Grind",
  pitch: "A hybrid platform that authentically reaches endurance athletes, music creators, and the high-performance lifestyle audience — across Europe and Latin America.",
  offers: [
    { title: "Sports Activations", desc: "Race kit branding, training content, event volunteering visibility, OCR & HYROX reach." },
    { title: "Music & SYNC", desc: "Custom branded tracks, beat drops, DJ sets and audio for your campaigns." },
    { title: "Content Partnership", desc: "70/20/10 content rule — authentic proof, lifestyle, and targeted commercial CTAs." },
    { title: "Hybrid Storytelling", desc: "Cross-platform narrative spanning Instagram, LinkedIn and long-form video." },
  ],
};

export const CONTACT = {
  emails: [
    { label: "Sports", value: "reycrosports@gmail.com" },
    { label: "Music", value: "reycromusic@gmail.com" },
  ],
  links: [
    { label: "Instagram · Sports", href: "https://www.instagram.com/reycrosports/" },
    { label: "Instagram · Music", href: "https://www.instagram.com/reycromusic/" },
    { label: "BeatStars", href: "https://reycromusic.beatstars.com" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/ianreynaud/" },
    { label: "EPK", href: "https://epkbuilder.com/site/reycro" },
    { label: "Linktree · Sports", href: "https://linktr.ee/reycrosports" },
    { label: "Linktree · Music", href: "https://linktr.ee/reycromusic" },
  ],
};
